"use client";
import { Navbar, Footer } from "@/components";

// sections
import RebottLocationsContent from "../../components/rebott-locations-content"; 
import RebottLocationsIntro from "../rebott-locations-intro"; 
import MapMarkers from "../map-markers";

export default function LocationsPage() {
  return (
    <>
      <Navbar />
      <RebottLocationsIntro />
      <RebottLocationsContent />
      <MapMarkers />
      <Footer />
    </>
  );
}
